// extracted by mini-css-extract-plugin
module.exports = {"inputArea":"InputField_inputArea__1cQ6q","label":"InputField_label__23G6p","input":"InputField_input__wG3Az"};